/**
 * Filename: dashboard-navigation.ts
 * Description: Shared URL-backed navigation rules for the Shin Q administration console.
 * Created by: Teddy Gil "Shin" Ravis Orbeta
 * Created: 2026-07-28
 * Updated: 2026-09-27
 */

export type DashboardSection = 'overview' | 'content' | 'users' | 'billing' | 'assets' | 'admins' | 'postal' | 'security' | 'safety' | 'privacy' | 'legal' | 'operations' | 'support' | 'audit' | 'animations';

export const DASHBOARD_NAV_ITEMS: ReadonlyArray<Readonly<{
  value: DashboardSection;
  label: string;
}>> = [
  { value: 'overview', label: 'Overview' },
  { value: 'content', label: 'Content preview' },
  { value: 'users', label: 'Users' },
  { value: 'billing', label: 'Billing' },
  { value: 'assets', label: 'Vocabulary assets' },
  { value: 'admins', label: 'Admin management' },
  { value: 'postal', label: 'Postal Code' },
  { value: 'security', label: 'Security & Threat Report' },
  { value: 'safety', label: 'Safety review' },
  { value: 'privacy', label: 'Privacy operations' },
  { value: 'legal', label: 'Legal content' },
  { value: 'operations', label: 'System operations' },
  { value: 'support', label: 'Support cases' },
  { value: 'audit', label: 'Audit events' },
  { value: 'animations', label: 'Animations & sounds' },
];

const DASHBOARD_SECTIONS = new Set<DashboardSection>(
  DASHBOARD_NAV_ITEMS.map(({ value }) => value),
);

export function dashboardSectionFromHash(hash: string): DashboardSection {
  const [candidate] = hash.replace(/^#\/?/, '').toLowerCase().split('/');
  return DASHBOARD_SECTIONS.has(candidate as DashboardSection)
    ? candidate as DashboardSection
    : 'overview';
}

export function dashboardSectionUrl(
  section: DashboardSection,
  location: Pick<Location, 'pathname' | 'search'>,
): string {
  return section === 'overview'
    ? `${location.pathname}${location.search}`
    : `#${section}`;
}
